import { useRef, useEffect, useState } from 'react';

const useTimeout = (callback: () => void, delay: number, deps: any[]) => {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    const timeout = window.setTimeout(() => {
      callbackRef.current();
    }, delay);

    return () => {
      window.clearTimeout(timeout);
    };
  }, deps);
};

const useOverTimeout = (delay: number): boolean => {
  const [overtime, setOvertime] = useState(false);

  useTimeout(() => setOvertime(true), delay, []);

  return overtime;
};

export { useTimeout, useOverTimeout };
